"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypeGuard_1 = require("../Types/TypeGuard");
class Assert {
    static notNull(value, message = '') {
        if (value === null) {
            throw new Error('Expected not null ' + message);
        }
        return value;
    }
    static notUndefined(value, message = '') {
        if (value === undefined) {
            throw new Error('Expected not undefined ' + message);
        }
        return value;
    }
    /**
     * Assert value is not null or undefined
     */
    static notNullable(value, message = '') {
        if (value === undefined || value === null) {
            throw new Error('Expected not null or undefined value ' + message);
        }
        return value;
    }
    static number(value, message = '') {
        if (TypeGuard_1.default.isNumber(value) === false) {
            throw new Error('Expected a number but got ' + (typeof value) + ' ' + message);
        }
        return value;
    }
}
exports.default = Assert;
//# sourceMappingURL=Assert.js.map